import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, Event, NavigationEnd, NavigationStart, NavigationCancel } from '@angular/router';
import { CommonService } from 'src/app/air/modules/common/service/common/common.service'
import { AirAppRoutes } from "src/app/air/modules/common/lib/air-api-constant";
import { StorageService } from '../storage/storage.service';


@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private currentNav!: INavigationData;
  private currentNavPromise = new BehaviorSubject<INavigationData>(this.currentNav);
  public $currentNav = this.currentNavPromise.asObservable();
  availableRoutes: any = {
    // HOME: this.commonService.getRoute({ route: AirAppRoutes.User.HOME, type: 'Manager' }),
    // TRACKING_LIST: this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST, type: 'User' }),
    // FAVORITE: this.commonService.getRoute({ route: AirAppRoutes.User.FAVORITE, type: 'User' }),
    // TRACKING_LIST_DETAILS: this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST_DETAILS, type: 'User' }),
    // TRACKING_LIST_DETAILS_HOME: this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST_DETAILS_HOME, type: 'User' }),
    // ETA_THRESHOLD: this.commonService.getRoute({ route: AirAppRoutes.User.ETA_THRESHOLD, type: 'User' }),
    // CHANGE_PASSWORD: this.commonService.getRoute({ route: AirAppRoutes.User.PROFILE + "/" + AirAppRoutes.User.CHANGE_PASSWORD, type: 'User' }),
    // OVERVIEW: this.commonService.getRoute({ route: AirAppRoutes.User.PROFILE + "/" + AirAppRoutes.User.OVERVIEW, type: 'User' }),
    // USER_CONTROL: this.commonService.getRoute({ route: AirAppRoutes.Manager.USER_CONTROL, type: 'Manager' }),
    // ASSIGN: this.commonService.getRoute({ route: AirAppRoutes.Manager.USER_CONTROL+'/assign', type: 'Manager' }),
    // EVENTS: this.commonService.getRoute({ route: AirAppRoutes.Manager.EVENTS_ROUTE, type: 'Manager' }),
    // PROFILE: this.commonService.getRoute({ route: AirAppRoutes.User.PROFILE, type: 'User' }),
    // EXCEPTION: this.commonService.getRoute({ route: AirAppRoutes.Manager.EXCEPTION, type: 'Manager' }),
    // DATA_UPLOAD: this.commonService.getRoute({ route: AirAppRoutes.Manager.DATA_UPLOAD, type: 'Manager' }),
    // VIEW_DATA: this.commonService.getRoute({ route: AirAppRoutes.Manager.DATA_UPLOAD + "/" + AirAppRoutes.Manager.VIEW_DATA, type: 'Manager' }),
    // VIEW_HISTORY: this.commonService.getRoute({ route: AirAppRoutes.Manager.DATA_UPLOAD + "/" + AirAppRoutes.Manager.VIEW_HISTORY, type: 'Manager' }),
    // TRACKING_LIST_DETAILS_FAVORITE: this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST_DETAILS_FAVORITE, type: 'User' }),
    // PRE_DEPARTURE_ALERTS: this.commonService.getRoute({ route: AirAppRoutes.User.ALERTS + "/" + AirAppRoutes.User.PRE_DEPARTURE_ALERTS, type: 'User' }),
    // INTRANSIT_ALERTS: this.commonService.getRoute({ route: AirAppRoutes.User.ALERTS + "/" + AirAppRoutes.User.INTRANSIT_ALERTS, type: 'User' }),
    // ALERTS: this.commonService.getRoute({ route: AirAppRoutes.User.ALERTS, type: 'User' }),
    // CUSTOMER_MANAGEMENT: this.commonService.getRoute({ route: AirAppRoutes.Manager.CUSTOMER_MANAGEMENT, type: 'Manager' }),
    // VESSELS: this.commonService.getRoute({ route: AirAppRoutes.Manager.VESSEL_SCHEDULE + '/' + AirAppRoutes.Manager.VESSELS, type: 'Manager' }),
    // ADD_VESSEL: this.commonService.getRoute({ route: AirAppRoutes.Manager.VESSEL_SCHEDULE + '/' + AirAppRoutes.Manager.ADD_VESSEL, type: 'Manager' }),
    // VESSEL_SCHEDULE: this.commonService.getRoute({ route: AirAppRoutes.Manager.VESSEL_SCHEDULE, type: 'Manager' }),
    // SHIPMENT_REPROCESSING: this.commonService.getRoute({ route: AirAppRoutes.Manager.SHIPMENT_REPROCESSING, type: 'Manager' }),
    // SHIPMENT_REPROCESSING_DSM: this.commonService.getRoute({ route: AirAppRoutes.Manager.SHIPMENT_REPROCESSING_DSM, type: 'Manager' }),
    // GEO_FENCING: this.commonService.getRoute({ route: AirAppRoutes.User.GEO_FENCE_MANAGER + '/' + AirAppRoutes.User.GEO_FENCING, type: 'User' }),
    // GEO_FENCE_MANAGER: this.commonService.getRoute({ route: AirAppRoutes.User.GEO_FENCE_MANAGER, type: 'User' }),
    // EXTERNAL_API_TRACKING_DETAILS: this.commonService.getRoute({ route: AirAppRoutes.DirectLink.EXTERNAL_API_TRACKING_DETAILS, type: 'DirectLink' }),
    // ALERT_SUBSCRIPTION: this.commonService.getRoute({ route: AirAppRoutes.Manager.ALERT_SUBSCRIPTION, type: 'Manager' }),
    // REPORTING_DASHBOARD: this.commonService.getRoute({ route: AirAppRoutes.User.REPORTING_DASHBOARD, type: 'Manager' }),
    // REPORTING_SSBI: this.commonService.getRoute({ route: AirAppRoutes.User.REPORTING_SSBI, type: 'Manager' }),
    // REPORTING_QLIK: this.commonService.getRoute({ route: AirAppRoutes.User.REPORTING_QLIK, type: 'Manager' }),
    // REPORTING_THOUHTSPOT: this.commonService.getRoute({ route: AirAppRoutes.User.REPORTING_THOUHTSPOT, type: 'Manager' }),
    // SOURCE_SYSTEM: this.commonService.getRoute({ route: AirAppRoutes.Manager.SOURCE_SYSTEM, type: 'Manager' }),
    // BDP_REP_EMAIL_MANAGEMENT: this.commonService.getRoute({ route: AirAppRoutes.Manager.BDP_REP_EMAIL_MANAGEMENT, type: 'Manager' }),
    // PETA_MANAGEMENT: this.commonService.getRoute({ route: AirAppRoutes.Manager.PETA_MANAGEMENT, type: 'Manager' }),

  };

  constructor(
    private router: Router,
    private commonService: CommonService,
    private storageService: StorageService) {
    this.availableRoutes = {

      HOME: this.commonService.getRoute({ route: AirAppRoutes.User.HOME, type: 'Manager' }),
      TRACKING_LIST: this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST, type: 'User' }),
      FAVORITE: this.commonService.getRoute({ route: AirAppRoutes.User.FAVORITE, type: 'User' }),
      TRACKING_LIST_DETAILS: this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST_DETAILS, type: 'User' }),
      TRACKING_LIST_DETAILS_HOME: this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST_DETAILS_HOME, type: 'User' }),
      ETA_THRESHOLD: this.commonService.getRoute({ route: AirAppRoutes.User.ETA_THRESHOLD, type: 'User' }),
      CHANGE_PASSWORD: this.commonService.getRoute({ route: AirAppRoutes.User.PROFILE + "/" + AirAppRoutes.User.CHANGE_PASSWORD, type: 'User' }),
      OVERVIEW: this.commonService.getRoute({ route: AirAppRoutes.User.PROFILE + "/" + AirAppRoutes.User.OVERVIEW, type: 'User' }),
      USER_CONTROL: this.commonService.getRoute({ route: AirAppRoutes.Manager.USER_CONTROL, type: 'Manager' }),
      ASSIGN: this.commonService.getRoute({ route: AirAppRoutes.Manager.USER_CONTROL + '/assign', type: 'Manager' }),
      EVENTS: this.commonService.getRoute({ route: AirAppRoutes.Manager.EVENTS_ROUTE, type: 'Manager' }),
      PROFILE: this.commonService.getRoute({ route: AirAppRoutes.User.PROFILE, type: 'User' }),
      EXCEPTION: this.commonService.getRoute({ route: AirAppRoutes.Manager.EXCEPTION, type: 'Manager' }),
      DATA_UPLOAD: this.commonService.getRoute({ route: AirAppRoutes.Manager.DATA_UPLOAD, type: 'Manager' }),
      VIEW_DATA: this.commonService.getRoute({ route: AirAppRoutes.Manager.DATA_UPLOAD + "/" + AirAppRoutes.Manager.VIEW_DATA, type: 'Manager' }),
      VIEW_HISTORY: this.commonService.getRoute({ route: AirAppRoutes.Manager.DATA_UPLOAD + "/" + AirAppRoutes.Manager.VIEW_HISTORY, type: 'Manager' }),
      FLIGHT_EQUIVALENCY_MANAGER: this.commonService.getRoute({ route: AirAppRoutes.User.FLIGHT_EQUIVALENCY_MANAGER, type: 'Manager' }),
    };

    // Handle the current URL on initialization
    const initialUrl = this.router.url;
    this.handleNavigation(initialUrl);

    // Subscribe to router events for subsequent navigations
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        const url = event.url;
        if (url) {
          this.handleNavigation(url);
        }
      }
    });
  }

  private handleNavigation(url: string) {
    this.setRedirectUrl(url);
    const navData: INavigationData = {
      route: url,
      routeType: this.availableRoutes.HOME
    }

    switch (navData.route) {
      case this.availableRoutes.HOME: {
        navData.routeType = AirAppRoutes.User.HOME;
        break;
      }
      case this.availableRoutes.TRACKING_LIST: {
        navData.routeType = AirAppRoutes.User.TRACKING_LIST;
        break;
      }
      case this.availableRoutes.ETA_THRESHOLD: {
        navData.routeType = AirAppRoutes.User.ETA_THRESHOLD;
        break;
      }
      case this.availableRoutes.CHANGE_PASSWORD: {
        navData.routeType = AirAppRoutes.User.CHANGE_PASSWORD;
        break;
      }
      case this.availableRoutes.OVERVIEW: {
        navData.routeType = AirAppRoutes.User.OVERVIEW;
        break;
      }
      case this.availableRoutes.PROFILE: {
        navData.routeType = AirAppRoutes.User.PROFILE;
        break;
      }
      case this.availableRoutes.EXCEPTION: {
        navData.routeType = AirAppRoutes.Manager.EXCEPTION;
        break;
      }
      case this.availableRoutes.USER_CONTROL: {
        navData.routeType = AirAppRoutes.Manager.USER_CONTROL;
        break;
      }
      
      case this.availableRoutes.ASSIGN: {
        navData.routeType = AirAppRoutes.Manager.ASSIGN;
        break;
      }
      case this.availableRoutes.EVENTS: {
        navData.routeType = AirAppRoutes.Manager.EVENTS_ROUTE;
        break;
      }
      case this.availableRoutes.DATA_UPLOAD: {
        navData.routeType = AirAppRoutes.Manager.DATA_UPLOAD;
        break;
      }
      case this.availableRoutes.VIEW_DATA: {
        navData.routeType = AirAppRoutes.Manager.VIEW_DATA;
        break;
      }
      case this.availableRoutes.VIEW_HISTORY: {
        navData.routeType = AirAppRoutes.Manager.VIEW_HISTORY;
        break;
      }

      case this.availableRoutes.FLIGHT_EQUIVALENCY_MANAGER: {
        navData.routeType = AirAppRoutes.User.FLIGHT_EQUIVALENCY_MANAGER;
        break;
      }
      // case this.availableRoutes.FAVORITE: {
      //   navData.routeType = AirAppRoutes.User.FAVORITE;
      //   break;
      // }
      // Adding AirAppRoutes.User.ALERTS due to same component used 
      // case this.availableRoutes.PRE_DEPARTURE_ALERTS: {
      //   navData.routeType = AirAppRoutes.User.PRE_DEPARTURE_ALERTS;
      //   break;
      // }
      // // Adding AirAppRoutes.User.ALERTS due to same component used 
      // case this.availableRoutes.INTRANSIT_ALERTS: {
      //   navData.routeType = AirAppRoutes.User.INTRANSIT_ALERTS;
      //   break;
      // }
      // Adding AirAppRoutes.User.ALERTS due to same component used 
      // case this.availableRoutes.ALERTS: {
      //   navData.routeType = AirAppRoutes.User.ALERTS;
      //   break;
      // }

      // case this.availableRoutes.VESSELS: {
      //   navData.routeType = AirAppRoutes.Manager.VESSELS;
      //   break;
      // }

      // case this.availableRoutes.ADD_VESSEL: {
      //   navData.routeType = AirAppRoutes.Manager.ADD_VESSEL;
      //   break;
      // }

      // case this.availableRoutes.GEO_FENCE_MANAGER: {
      //   navData.routeType = AirAppRoutes.User.GEO_FENCE_MANAGER;
      //   break
      // }


      // case this.availableRoutes.SHIPMENT_REPROCESSING: {
      //   navData.routeType = AirAppRoutes.Manager.SHIPMENT_REPROCESSING;
      //   break;
      // }

      // case this.availableRoutes.SHIPMENT_REPROCESSING_DSM: {
      //   navData.routeType = AirAppRoutes.Manager.SHIPMENT_REPROCESSING_DSM;
      //   break;
      // }

      // case this.availableRoutes.BDP_REP_EMAIL_MANAGEMENT: {
      //   navData.routeType = AirAppRoutes.Manager.BDP_REP_EMAIL_MANAGEMENT;
      //   break;
      // }

      // case this.availableRoutes.GEO_FENCING: {
      //   navData.routeType = AirAppRoutes.User.GEO_FENCING;
      //   break;
      // }

      // case this.availableRoutes.ALERT_SUBSCRIPTION: {
      //   navData.routeType = AirAppRoutes.Manager.ALERT_SUBSCRIPTION;
      //   break;
      // }

      // case this.availableRoutes.SOURCE_SYSTEM: {
      //   navData.routeType = AirAppRoutes.Manager.SOURCE_SYSTEM;
      //   break;
      // }

      // case this.availableRoutes.REPORTING_DASHBOARD: {
      //   navData.routeType = AirAppRoutes.User.REPORTING_DASHBOARD;
      //   break;
      // }
      // case this.availableRoutes.REPORTING_SSBI: {
      //   navData.routeType = AirAppRoutes.User.REPORTING_SSBI;
      //   break;
      // }
      // case this.availableRoutes.REPORTING_QLIK: {
      //   navData.routeType = AirAppRoutes.User.REPORTING_QLIK;
      //   break;
      // }
      // case this.availableRoutes.REPORTING_THOUHTSPOT: {
      //   navData.routeType = AirAppRoutes.User.REPORTING_THOUHTSPOT;
      //   break;
      // }
      // case this.availableRoutes.PETA_MANAGEMENT: {
      //   navData.routeType = AirAppRoutes.Manager.PETA_MANAGEMENT;
      //   break;
      // }
      default: {
        if (navData.route.includes(this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST_DETAILS, type: 'User' }))) {
          navData.routeType = AirAppRoutes.User.TRACKING_LIST_DETAILS;
        }
        if (navData.route.includes(this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST_DETAILS_HOME, type: 'User' }))) {
          navData.routeType = AirAppRoutes.User.TRACKING_LIST_DETAILS_HOME;
        }
        // if (navData.route.includes('assign')) {
        //   navData.routeType = AirAppRoutes.Manager.ASSIGN;
        // }
        // if (navData.route.includes('overview')) {
        //   navData.routeType = AirAppRoutes.User.PROFILE;
        // }
        // if (navData.route.includes('change-password')) {
        //   navData.routeType = AirAppRoutes.User.CHANGE_PASSWORD;
        // }
        // if (navData.route.includes(this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST_DETAILS_FAVORITE, type: 'User' }))) {
        //   navData.routeType = AirAppRoutes.User.TRACKING_LIST_DETAILS_FAVORITE;
        // }
        break;
      }
    }

    this.currentNav = navData;
    this.currentNavPromise.next(navData);
  }

  private setRedirectUrl(url: string) {
    // Sets redirect to Home page
    this.storageService.setItem('redirectUrl', `${this.availableRoutes.HOME}`);
  }
}

export interface INavigationData {
  route: string;
  routeType: string;
}
